import React, { useState } from "react";
import { Space, Table, Row, Col, Button, message } from "antd";
import AdministrativeCasesModal from "./AdministrativeCasesModal";
import { removeViolation } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { AdministrativeVoilationColumns } from "../../../../PQQ/tableColumns";

const AdministrativeCases = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const openModal = (action) => {
    setVisible(true);
    setEditTable(action);
  };

  const refreshPage = () => {
    props.fetchViolationCases(props.vendorId);
  };

  const removeColumn = (id) => {
    removeViolation({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...AdministrativeVoilationColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, form_status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Violation
        </Button>
      </Col>
      <Col span={22} offset={1}>
        <Table
          size="small"
          columns={columns}
          dataSource={props.data}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <AdministrativeCasesModal
          setVisible={setVisible}
          title="Add Administrative Violation"
          vendorId={props.vendorId}
          tableData={props.data}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default AdministrativeCases;
